module.exports = __webpack_public_path__ + "media/src/images/partners/tusur-52f952845a8387a7c29b5f2c2a35e528.jpg";